@use 'variables' as *;
@use 'mixins' as *;

:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

.label-aria {
  @include cat-visually-hidden;
}

cat-date-inline {
  margin: 1rem;
  width: 20rem;
}
